const urlPrefix = 'legal'

const supportedLanguages = ['pt-br', 'en', 'es,', 'fr', 'it', 'ja']

const i18nPages = {
  index: {
    'pt-br': `/${urlPrefix}`,
    en: `/${urlPrefix}`,
    es: `/${urlPrefix}`,
    fr: `/${urlPrefix}`,
    it: `/${urlPrefix}`,
    ja: `/${urlPrefix}`,
  },
  'cookies-policy': {
    'pt-br': `/${urlPrefix}/politica-de-cookies`,
    en: `/${urlPrefix}/cookies-policy`,
    es: `/${urlPrefix}/politica-de-cookies`,
    fr: `/${urlPrefix}/politique-de-cookies`,
    it: false,
    ja: false,
  },
  'cybersecurity-policy': {
    'pt-br': `/${urlPrefix}/politica-de-seguranca-cibernetica`,
    en: `/${urlPrefix}/cybersecurity-policy`,
    es: `/${urlPrefix}/politica-de-seguridad`,
    fr: `/${urlPrefix}/politique-de-securite`,
    it: false,
    ja: false,
  },
  'data-privacy-policy': {
    'pt-br': `/${urlPrefix}/privacidade-de-dados`,
    en: `/${urlPrefix}/data-privacy-policy`,
    es: `/${urlPrefix}/privacidad-de-datos`,
    fr: `/${urlPrefix}/politique-de-confidentialite`,
    it: `/${urlPrefix}/politica-sulla-privacy`,
    ja: `/${urlPrefix}${encodeURI('/プライバシーポリシー')}`,
  },
  glossary: {
    'pt-br': `/${urlPrefix}/glossario`,
    en: `/${urlPrefix}/glossary`,
    es: `/${urlPrefix}/glosario`,
    fr: `/${urlPrefix}/glossaire`,
    it: `/${urlPrefix}/glossario`,
    ja: `/${urlPrefix}${encodeURI('/の利用規約の用語集')}`,
  },
  'payments-policy': {
    'pt-br': `/${urlPrefix}/politicas-de-pagamento`,
    en: `/${urlPrefix}/payments-policy`,
    es: `/${urlPrefix}/politica-de-pago`,
    fr: `/${urlPrefix}/politique-de-paiements`,
    it: `/${urlPrefix}/politica-di-pagamento`,
    ja: `/${urlPrefix}${encodeURI('/一般支払規約')}`,
  },
  'purchase-terms': {
    'pt-br': `/${urlPrefix}/termos-de-compra`,
    en: `/${urlPrefix}/purchase-terms`,
    es: `/${urlPrefix}/plazo-de-compra`,
    fr: `/${urlPrefix}/conditions-generales-dachat`,
    it: `/${urlPrefix}/termini-generali-di-acquisto`,
    ja: `/${urlPrefix}${encodeURI('/購入規約')}`,
  },
  'responsible-use-policy': {
    'pt-br': `/${urlPrefix}/politicas-de-uso`,
    en: `/${urlPrefix}/responsible-use-policy`,
    es: `/${urlPrefix}/politicas-de-uso`,
    fr: `/${urlPrefix}/politique-generale-dutilisation-responsable`,
    it: `/${urlPrefix}/politica-generale-di-utilizzo-responsabile`,
    ja: `/${urlPrefix}${encodeURI('/の責任ある使用の一般ポリシー')}`,
  },
  'terms-of-use': {
    'pt-br': `/${urlPrefix}/termos-de-uso`,
    en: `/${urlPrefix}/terms-of-use`,
    es: `/${urlPrefix}/terminos-de-uso`,
    fr: `/${urlPrefix}/conditions-generales-dutilisation`,
    it: `/${urlPrefix}/termini-generali-di-utilizzo`,
    ja: `/${urlPrefix}${encodeURI('/利用規約')}`,
  },
  'co-creation-terms-of-use': {
    'pt-br': `/${urlPrefix}/termos-de-uso-da-coproducao`,
    en: `/${urlPrefix}/co-creation-terms-of-use`,
    es: `/${urlPrefix}/terminos-de-uso-de-la-coproduccion`,
    fr: `/${urlPrefix}/conditions-dutilisation-de-la-coproduction`,
    it: `/${urlPrefix}/termini-di-utilizzo-della-coproduzione`,
    ja: `/${urlPrefix}${encodeURI('/コ・プロダクション利用規約')}`,
  },
  'whatsapp-business': {
    'pt-br': `/${urlPrefix}/whatsapp-business`,
    en: `/${urlPrefix}/whatsapp-business`,
    es: `/${urlPrefix}/whatsapp-business`,
    fr: false,
    it: false,
    ja: false,
  },
  'privacy-policy': {
    'pt-br': `/${urlPrefix}/aviso-de-privacidade`,
    en: `/${urlPrefix}/privacy-notice`,
    es: `/${urlPrefix}/aviso-de-privacidad`,
    fr: false,
    it: false,
    ja: false,
  },
  'hotmart-card-policies': {
    'pt-br': `/${urlPrefix}/politicas-do-cartao-hotmart-para-o-brasil`,
    en: `/${urlPrefix}/hotmart-card-policies`,
    es: `/${urlPrefix}/politicas-de-tarjetas-hotmart`,
    fr: false,
    it: false,
    ja: false,
  },
  'data-processing-agreement/creators/index': {
    'pt-br': `/${urlPrefix}/termo-de-tratamento-de-dados-pessoais-creators`,
    en: `/${urlPrefix}/data-processing-agreement`,
    es: `/${urlPrefix}/termino-de-tratamiento-de-datos-personales-creadores`,
    fr: false,
    it: false,
    ja: false,
  },
  'data-processing-agreement/suppliers/index': {
    'pt-br': `/${urlPrefix}/acordo-de-tratamento-de-dados-pessoais-fornecedor`,
    en: `/${urlPrefix}/data-processing-agreement-suppliers`,
    es: `/${urlPrefix}/acuerdo-de-tratamiento-de-datos-personales-proveedor`,
    fr: false,
    it: false,
    ja: false,
  },
  'data-processing-agreement/suppliers/appendix-i': {
    'pt-br': `/${urlPrefix}/acordo-de-tratamento-de-dados-pessoais-fornecedor-anexo-i`,
    en: `/${urlPrefix}/data-processing-agreement-suppliers-appendix-i`,
    es: `/${urlPrefix}/acuerdo-de-tratamiento-de-datos-personales-proveedor-apendice-i`,
    fr: false,
    it: false,
    ja: false,
  },
  'data-processing-agreement/suppliers/appendix-ii': {
    'pt-br': `/${urlPrefix}/acordo-de-tratamento-de-dados-pessoais-fornecedor-anexo-ii`,
    en: `/${urlPrefix}/data-processing-agreement-suppliers-appendix-ii`,
    es: `/${urlPrefix}/acuerdo-de-tratamiento-de-datos-personales-proveedor-apendice-ii`,
    fr: false,
    it: false,
    ja: false,
  },
  'data-processing-agreement/suppliers/appendix-iii': {
    'pt-br': `/${urlPrefix}/acordo-de-tratamento-de-dados-pessoais-fornecedor-anexo-iii`,
    en: `/${urlPrefix}/data-processing-agreement-suppliers-appendix-iii`,
    es: `/${urlPrefix}/acuerdo-de-tratamiento-de-datos-personales-proveedor-apendice-iii`,
    fr: false,
    it: false,
    ja: false,
  },
  'data-processing-agreement/suppliers/appendix-iv': {
    'pt-br': `/${urlPrefix}/acordo-de-tratamento-de-dados-pessoais-fornecedor-anexo-iv`,
    en: `/${urlPrefix}/data-processing-agreement-suppliers-appendix-iv`,
    es: `/${urlPrefix}/acuerdo-de-tratamiento-de-datos-personales-proveedor-apendice-iv`,
    fr: false,
    it: false,
    ja: false,
  },
}

export default i18nPages
